import { useState } from "react";

function TermSelect(props) {

  const [defaultValue, setDefaultValue] = useState(props.coursesObj.SISTermID);

  function handleStateChange (e) {
    let coursesObj = props.coursesObj;
    setDefaultValue(e.target.value);
      props.setCoursesObj({
        ...coursesObj,
        SISTermID: e.target.value,
        default: false,
      });
  }

  return (
      <>
        {defaultValue === '202740'
            ?
            <>
              <label htmlFor="Term Selection" className="majorLabel">Term:</label>
              <input type="radio" id="Summer Semester 2026" name="SISTermID" value="202710" className="radio"
                     onChange={handleStateChange}/>
              <label htmlFor="Summer Semester 2026">Summer Semester 2026</label>
              <br></br>
              <input type="radio" id="Fall Semester 2026" name="SISTermID" value="202720" className="radio"
                     onChange={handleStateChange}/>
              <label htmlFor="Fall Semester 2026">Fall Semester 2026</label>
              <br></br>
              <input type="radio" id="Spring Semester 2027" name="SISTermID" value="202740" className="radio" checked
                     onChange={handleStateChange}/>
              <label htmlFor="Spring Semester 2026">Spring Semester 2027</label>
            </>
            :
            null
        }
        {defaultValue === '202710'
            ?
            <>
              <label htmlFor="Term Selection" className="majorLabel">Term:</label>
              <input type="radio" id="Summer Semester 2026" name="SISTermID" value="202710" className="radio" checked
                     onChange={handleStateChange}/>
              <label htmlFor="Summer Semester 2026">Summer Semester 2026</label>
              <br></br>
              <input type="radio" id="Fall Semester 2026" name="SISTermID" value="202720" className="radio"
                     onChange={handleStateChange}/>
              <label htmlFor="Fall Semester 2026">Fall Semester 2026</label>
              <br></br>
              <input type="radio" id="Spring Semester 2027" name="SISTermID" value="202740" className="radio"
                     onChange={handleStateChange}/>
              <label htmlFor="Spring Semester 2026">Spring Semester 2027</label>
            </>
            :
            null
        }
        {defaultValue === '202720'
            ?
            <>
              <label htmlFor="Term Selection" className="majorLabel">Term:</label>
              <input type="radio" id="Summer Semester 2026" name="SISTermID" value="202710" className="radio"
                     onChange={handleStateChange}/>
              <label htmlFor="Summer Semester 2026">Summer Semester 2026</label>
              <br></br>
              <input type="radio" id="Fall Semester 2026" name="SISTermID" value="202720" className="radio" checked
                     onChange={handleStateChange}/>
              <label htmlFor="Fall Semester 2026">Fall Semester 2026</label>
              <br></br>
              <input type="radio" id="Spring Semester 2027" name="SISTermID" value="202740" className="radio"
                     onChange={handleStateChange}/>
              <label htmlFor="Spring Semester 2026">Spring Semester 2027</label>
            </>
            :
            null
        }
      </>
  );
}

export default TermSelect;
